import FiltersMixin from '@/Core/mixins/FiltersMixin'
import { Store } from '@/Core/Models/Stores'
import { BillConcept } from '@/Modules/Bills/models'
import { Component, MapGetter, mixins } from 'types-vue'

@Component
export default class BillConceptsTable extends mixins(FiltersMixin) {

  @MapGetter(Store.BillDetails) protected concepts: BillConcept[]
}